<template>
  <div class="relative">
    <TextInput
      v-model="localValue"
      class="w-full"
      v-bind="{
        inputClasses,
        labelClasses,
        helperClasses,
        errorMessageClasses,
        type,
        placeholder,
        error,
        label,
      }"
      @keydown="handleKeydown"
    />
    <div
      v-if="passwordShown"
      class="absolute right-4 top-[44px] w-[16px] h-[16px] cursor-pointer flex items-center justify-center"
    >
      <img
        src="/assets/icons/register/eye-show.svg"
        class="w-[16px] h-[16px]"
        @click="togglePassword()"
      />
    </div>
    <div
      v-else
      class="absolute right-4 top-[44px] w-[16px] h-[16px] cursor-pointer flex items-center justify-center"
    >
      <img
        src="/assets/icons/register/eye-hide.svg"
        class="w-[16px] h-[16px]"
        @click="togglePassword()"
      />
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/design/TextInput.vue';
import HasLocalValue from '@/mixins/HasLocalValue';
import HasInputClassProps from '@/mixins/HasInputClassProps';

export default {
  components: {
    TextInput,
  },

  mixins: [HasLocalValue, HasInputClassProps],

  props: {
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    inputClasses: {
      type: [String, Array, Object],
      default: null,
    },
  },

  data() {
    return {
      passwordShown: false,
    };
  },

  computed: {
    type() {
      return this.passwordShown ? 'text' : 'password';
    },
  },

  methods: {
    togglePassword() {
      this.passwordShown = !this.passwordShown;
    },
    handleKeydown(event) {
      // Prevent space input for password fields
      if (event.key === ' ') {
        event.preventDefault();
      }
    },
  },
};
</script>
